/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

export const expectedDropFile = {
  path: 'test.pdf',
  name: 'test.pdf',
};

export const submission = {
  tenantId: 'EPO',
  id: 'c0a80105-766b-1eec-8176-6bd2dfa70000',
  userReference: 't',
  titleOfInvention: null,
  declaration: null,
  createdDate: '2020-12-16T13:52:30.719+00:00',
  modifiedDate: '2020-12-17T11:03:51.802+00:00',
  userId: '55db5d99-85ca-4c17-ac8d-5838ba7af1bb',
  lockUser: '55db5d99-85ca-4c17-ac8d-5838ba7af1bb',
  status: 'DRAFT',
  parties: [],
  priorityDeclarationIntent: false,
  signature: null,
  receipt: null,
};

export const claims = {
  submission,
  tenantId: 'EPO',
  id: '16e141f4-f559-4f9e-8ccc-12fc5e415ed9',
  attachmentType: 'CLAIMS',
  fileName: 'SPECEPO-1.pdf',
  originalFileName: 'test.pdf',
  mimeType: 'application/pdf',
  bytes: 28550,
  totalPages: 1,
  numberOfClaims: 4,
  combinedFileTypeScopes: [],
  additionalFieldRequired: false,
  hideAdditionalField: false,
};

export const general = {
  submission,
  tenantId: 'EPO',
  id: '335a9f65-e859-4e6a-a317-b5b2ad4d4c67',
  attachmentType: 'GENERAL',
  fileName: 'SPECEPO-2.pdf',
  originalFileName: 'test2.pdf',
  mimeType: 'application/pdf',
  bytes: 28550,
  totalPages: 1,
  numberOfClaims: null,
  figureToBePublished: '3A',
  combinedFileTypeScopes: [],
};

export const mockAttachmentsTypes = {
  attachmentsConfiguration: {
    attachmentTypes: [
      {
        type: 'DESCRIPTION',
        systemFileName: 'SPECEPO',
        docTypeLabel: 'SPECEPO',
        description: '',
        subType: 'TECHNICAL',
        needDistinctTypes: true,
        acceptedMimeTypes: ['application/pdf'],
        acceptedFileExtensions: ['pdf'],
      },
      {
        type: 'CLAIMS',
        systemFileName: 'SPECEPO',
        docTypeLabel: 'SPECEPO',
        description: '',
        subType: 'TECHNICAL',
        needDistinctTypes: true,
        acceptedMimeTypes: ['application/pdf'],
        acceptedFileExtensions: ['pdf'],
        additionalFieldRequired: true,
      },
      {
        type: 'ABSTRACT',
        systemFileName: 'SPECEPO',
        docTypeLabel: 'SPECEPO',
        description: '',
        subType: 'TECHNICAL',
        needDistinctTypes: true,
        acceptedMimeTypes: ['application/pdf'],
        acceptedFileExtensions: ['pdf'],
        additionalFieldRequired: true,
      },
      {
        type: 'DRAWINGS',
        systemFileName: 'SPECEPO',
        docTypeLabel: 'SPECEPO',
        description: '',
        subType: 'TECHNICAL',
        needDistinctTypes: true,
        acceptedMimeTypes: ['application/pdf'],
        acceptedFileExtensions: ['pdf'],
      },
      {
        type: 'COMBINED',
        systemFileName: 'SPECEPO',
        docTypeLabel: 'SPECEPO',
        description: '',
        subType: 'TECHNICAL',
        needDistinctTypes: true,
        acceptedMimeTypes: ['application/pdf'],
        acceptedFileExtensions: ['pdf'],
      },
      {
        type: 'GENERAL',
        systemFileName: 'GENAUTH',
        docTypeLabel: '1004',
        description: 'General authorisation',
        subType: 'ADDITIONAL',
        needDistinctTypes: false,
        acceptedMimeTypes: ['application/pdf'],
        acceptedFileExtensions: ['pdf'],
      },
      {
        type: 'SPECIFIC',
        systemFileName: 'SPECAUTH',
        docTypeLabel: '1003',
        description: 'Specific authorisation',
        subType: 'ADDITIONAL',
        needDistinctTypes: false,
        acceptedMimeTypes: ['application/pdf'],
        acceptedFileExtensions: ['pdf'],
      },
      {
        type: 'SEARCH',
        systemFileName: 'PRSR',
        docTypeLabel: 'PRSR-REF',
        description: 'Search results required under Rule 141',
        subType: 'ADDITIONAL',
        needDistinctTypes: false,
        acceptedMimeTypes: ['application/pdf'],
        acceptedFileExtensions: ['pdf'],
      },
      {
        type: 'OTHER',
        systemFileName: 'OTHER',
        docTypeLabel: 'OTHERPDF',
        description: 'Assignment documents',
        subType: 'ADDITIONAL',
        needDistinctTypes: false,
        acceptedMimeTypes: ['application/pdf'],
        acceptedFileExtensions: ['pdf'],
      },
      {
        type: 'PAYMENT',
        systemFileName: 'PYMTDOC',
        docTypeLabel: 'PYMTDOC',
        description: 'Payment documents',
        subType: 'PAYMENT',
        needDistinctTypes: true,
        acceptedMimeTypes: ['application/pdf'],
        acceptedFileExtensions: ['pdf'],
      },
      {
        type: 'EXHIBITION',
        systemFileName: 'UNKOWN',
        docTypeLabel: 'UNKOWN',
        description: 'Exhibition certificate',
        subType: 'ADDITIONAL',
        needDistinctTypes: true,
        acceptedMimeTypes: ['application/pdf'],
        acceptedFileExtensions: ['pdf'],
      },
      {
        type: 'RIGHT_TO_FILE',
        systemFileName: 'UNKOWN',
        docTypeLabel: 'UNKOWN',
        description: 'Right to file a patent application',
        subType: 'ADDITIONAL',
        needDistinctTypes: true,
        acceptedMimeTypes: ['application/pdf'],
        acceptedFileExtensions: ['pdf'],
      },
      {
        type: 'INVENTORSHIP',
        systemFileName: 'UNKOWN',
        docTypeLabel: 'UNKOWN',
        description: 'Declaration regarding inventorship',
        subType: 'ADDITIONAL',
        needDistinctTypes: true,
        acceptedMimeTypes: ['application/pdf'],
        acceptedFileExtensions: ['pdf'],
      },
      {
        type: 'INVENTOR_WAIVER',
        systemFileName: 'INVENTOR_WAIVER',
        docTypeLabel: 'INVENTOR_WAIVER',
        description: 'Inventor waiver document',
        subType: 'ADDITIONAL',
        needDistinctTypes: false,
        acceptedMimeTypes: ['application/pdf'],
        acceptedFileExtensions: ['pdf'],
      },
      {
        type: 'ELECTRONIC_PRIORITY',
        systemFileName: 'ELECTRONIC_PRIORITY',
        docTypeLabel: 'ELECTRONIC_PRIORITY',
        description: 'Electronic priority documents',
        subType: 'ADDITIONAL',
        needDistinctTypes: false,
        acceptedMimeTypes: ['application/pdf'],
        acceptedFileExtensions: ['pdf'],
      },
      {
        type: 'TRANSLATION_OF_TECHNICAL_DOCUMENTS',
        systemFileName: 'TRANSLATION_OF_TECHNICAL_DOCUMENTS',
        docTypeLabel: 'TRANSLATION_OF_TECHNICAL_DOCUMENTS',
        description: 'Translation of TECHNICAL documents',
        subType: 'ADDITIONAL',
        needDistinctTypes: false,
        acceptedMimeTypes: ['application/pdf'],
        acceptedFileExtensions: ['pdf'],
      },
      {
        type: 'TRANSLATIONS_OF_PRIORITY_DOCUMENTS',
        systemFileName: 'TRANSLATIONS_OF_PRIORITY_DOCUMENTS',
        docTypeLabel: 'TRANSLATIONS_OF_PRIORITY_DOCUMENTS',
        description: 'Translations of priority documents',
        subType: 'ADDITIONAL',
        needDistinctTypes: false,
        acceptedMimeTypes: ['application/pdf'],
        acceptedFileExtensions: ['pdf'],
      },
      {
        type: 'BIO_MATERIAL',
        systemFileName: 'BIO_MATERIAL',
        docTypeLabel: 'BIO_MATERIAL_DOC',
        description: 'Bio Material Data',
        subType: 'BIO_MATERIAL',
        needDistinctTypes: false,
        acceptedMimeTypes: [
          'application/pdf',
          'image/jpeg',
          'image/png',
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        ],
        acceptedFileExtensions: [
          'pdf',
          'doc',
          'docx',
          'jpg',
          'jpeg',
          'png',
        ],
      },
      {
        type: 'SEQ_LIST',
        systemFileName: 'SEQ_LIST',
        docTypeLabel: 'SEQL',
        description: 'Sequece listing',
        subType: 'SEQ',
        needDistinctTypes: true,
        acceptedMimeTypes: ['text/xml'],
        acceptedFileExtensions: ['xml'],
      },
      {
        type: 'SPC_1',
        systemFileName: 'SPC_1',
        docTypeLabel: 'SPC_1',
        subType: 'SPC',
        acceptedMimeTypes: ['application/pdf'],
        acceptedFileExtensions: ['pdf'],
      },
      {
        type: 'SPC_2',
        systemFileName: 'SPC_2',
        docTypeLabel: 'SPC_2',
        subType: 'SPC',
        acceptedMimeTypes: ['application/pdf'],
        acceptedFileExtensions: ['pdf'],
        dropdownDefinition: 'country',
      },
      {
        type: 'SA_1',
        systemFileName: 'SA_1',
        docTypeLabel: 'SA_1',
        subType: 'SA',
        acceptedMimeTypes: ['application/pdf'],
        acceptedFileExtensions: ['pdf'],
      },
      {
        type: 'SA_2',
        systemFileName: 'SA_2',
        docTypeLabel: 'SA_2',
        subType: 'SA',
        acceptedMimeTypes: ['application/pdf'],
        acceptedFileExtensions: ['pdf'],
        dropdownDefinition: 'country',
      },
      {
        type: 'PRE-CONVERSION',
        systemFileName: 'OLF-ARCHIVE',
        noSystemFileNameIndexing: true,
        docTypeLabel: 'OLF-ARCHIVE',
        description: 'Pre conversion archive',
        subType: 'TECHNICAL',
        needDistinctTypes: true,
        acceptedMimeTypes: ['application/zip', 'application/x-zip-compressed'],
        acceptedFileExtensions: ['zip'],
      },
    ],
  },
};
